const DEFAULT_ARTIST_SPLITTER_RULES = [
    { value: ',', enabled: true, builtin: true },
    { value: '\\', enabled: true, builtin: true },
    { value: '&', enabled: true, builtin: true },
    { value: '+', enabled: true, builtin: true },
    { value: '|', enabled: true, builtin: true },
    { value: '、', enabled: true, builtin: true },
    { value: '，', enabled: true, builtin: true },
    { value: ';', enabled: true, builtin: true },
    { value: '-', enabled: true, builtin: true },
    { value: '_', enabled: true, builtin: true },
    { value: 'ft.', enabled: true, builtin: true },
    { value: 'feat.', enabled: true, builtin: true },
    { value: 'Feat.', enabled: true, builtin: true },
    { value: '\u0000', enabled: true, builtin: true },
    { value: '\x00', enabled: true, builtin: true }
]

function normalizeRules(rawRules) {
    const rules = []
    DEFAULT_ARTIST_SPLITTER_RULES.forEach((rule) => {
        if (rules.some(item => item.value === rule.value)) {
            return
        }
        rules.push({ ...rule })
    })
    const indexMap = new Map(rules.map((rule, index) => [rule.value, index]))

    if (!Array.isArray(rawRules)) {
        return rules
    }

    rawRules.forEach((rule) => {
        if (!rule || typeof rule !== 'object') {
            return
        }

        const value = typeof rule.value === 'string' ? rule.value : ''
        if (!value) {
            return
        }

        if (indexMap.has(value)) {
            rules[indexMap.get(value)].enabled = Boolean(rule.enabled)
            return
        }

        indexMap.set(value, rules.length)
        rules.push({
            value,
            enabled: Boolean(rule.enabled),
            builtin: false
        })
    })

    return rules
}

export function getArtistSplitterRules(sysDict = {}) {
    return normalizeRules(sysDict.artist_splitter_rules)
}

export function splitArtistText(value, sysDict = {}) {
    if (typeof value !== 'string') {
        return Array.isArray(value) ? value : []
    }

    const delimiters = getArtistSplitterRules(sysDict)
        .filter(rule => rule.enabled && rule.value)
        .map(rule => rule.value)
        .sort((left, right) => right.length - left.length)

    if (!delimiters.length) {
        return [value].filter(Boolean)
    }

    const regex = new RegExp(delimiters.map(d => d.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g')
    return value.split(regex).map(item => item.trim()).filter(item => item)
}

export { DEFAULT_ARTIST_SPLITTER_RULES }
